// External dependencies
import { gql } from '@apollo/client';

export const updateCategoryMutation = gql`
  mutation updateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      id
    }
  }
`;
